import { LoadingSpinner } from '@/shared/components';

/**
 * 성취기준 카드 로딩 상태 표시 컴포넌트.
 * 중앙에 스피너를 표시합니다.
 */
export const StandardLoadingState = () => {
  return <div className="flex size-full items-center justify-center" data-sentry-component="StandardLoadingState" data-sentry-source-file="StandardLoadingState.tsx">
      <div className="flex w-fit flex-col items-center justify-center gap-xs rounded-sm bg-white px-xl py-lg">
        <LoadingSpinner className="size-[40px] text-strong" data-sentry-element="LoadingSpinner" data-sentry-source-file="StandardLoadingState.tsx" />
        <span className="text-body-md-bold text-alternative">Loading</span>
      </div>
    </div>;
};